<template>
    <v-dialog v-model="dialog" max-width="805" content-class="custom-dialog-content">
        <v-overlay color="#106c68" :value="callApiPending" z-index="12">
            <span class="loader"></span>
        </v-overlay>
        <v-card class="dialog-evaluate font-theme">
            <v-form class="pt-8 pb-4 px-9">
                <v-row align="center" class="standard-row title-evalute mb-9" no-gutters>
                    ประเมินผู้ขาย
                </v-row>
                <v-row v-for="(item, index) in evalData" :key="index" class="standard-row form-evaluate" justify="start"
                    align="center" no-gutters>
                    <v-col cols="12" md="6">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="5" sm="4" class="pb-1 px-md-0 pb-sm-3">
                                รายการใบสั่งซื้อที่เลือก
                            </v-col>
                            <v-col cols="12" md="7" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-text-field v-model="item.po_number" readonly hide-details outlined dense
                                    class="border-radius-box text-filed-custom"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="4" sm="4" class="pb-1 pr-md-0 pb-sm-3">
                                Vendor Name
                            </v-col>
                            <v-col cols="12" md="8" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-text-field v-model="item.vendor_name" readonly hide-details outlined dense
                                    class="border-radius-box text-filed-custom"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="5" sm="4" class="pb-1 px-md-0 pb-sm-3">
                                Currency
                            </v-col>
                            <v-col cols="12" md="7" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-text-field v-model="item.currency" readonly hide-details outlined dense
                                    class="border-radius-box text-filed-custom"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="4" sm="4" class="pb-1 pr-md-0 pb-sm-3">
                                Net Price
                            </v-col>
                            <v-col cols="12" md="8" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-text-field v-model="item.net_price" readonly hide-details outlined dense
                                    class="border-radius-box text-filed-custom"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="5" sm="4" class="pb-1 px-md-0 pb-sm-3">
                                VatAmount
                            </v-col>
                            <v-col cols="12" md="7" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-text-field v-model="item.vat_amount" readonly hide-details outlined dense
                                    class="border-radius-box text-filed-custom"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="4" sm="4" class="pb-1 pr-md-0 pb-sm-3">
                                NetAmount
                            </v-col>
                            <v-col cols="12" md="8" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-text-field v-model="item.net_amount" readonly hide-details outlined dense
                                    class="border-radius-box text-filed-custom"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="10">
                        <v-row class="standard-row" align="center">
                            <v-col cols="12" md="3" sm="4" class="pb-1 px-md-0 pb-sm-3">
                                HeaderText
                            </v-col>
                            <v-col cols="12" md="9" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                <v-textarea v-model="item.header_text" readonly no-resize hide-details outlined dense
                                    class="border-radius-box textarea-custom scroll-theme">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-row class="standard-row" align="center">
                        <v-col cols="12" md="6" class="px-0">
                            <v-row class="standard-row" align="center">
                                <v-col cols="12" md="5" sm="4" class="pb-0 px-md-0 pb-sm-3">
                                    Remark
                                </v-col>
                                <v-col cols="12" md="7" sm="8" class="py-0 py-sm-3 pl-sm-0">
                                    <v-text-field v-model="item.document_id" readonly hide-details outlined dense
                                        class="border-radius-box text-filed-custom"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-row>
                <v-row class="standard-row" no-gutters>
                    <v-spacer></v-spacer>
                    <v-btn width="112px" height="39px" color="white" text depressed @click="toEvalData()"
                        class="btn-custom">
                        NEXT
                    </v-btn>
                </v-row>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
import { EventBus } from '@/EventBus';
export default {
    data: () => ({
        dialog: false,
        evalData: [],
        defaultFormData: [],
        callApiPending: 0,
        evalDialogData: {}
    }),
    mounted() {
        EventBus.$on('toEvalDialog', this.openDialog)
    },
    beforeDestroy() {
        EventBus.$off("toEvalDialog")
        this.callApiPending = 0
    },
    watch: {
        "dialog"(newVal) {
            if (!newVal) {
                this.evalData = [];
            }
        }
    },
    methods: {
        openDialog(data) {
            this.evalDialogData = data
            this.getEvalVendor()
            this.dialog = true
        },
        toEvalData() {
            this.$router.push({ path: "/eval_vendor_detail" })
        },
        async getEvalVendor() {
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/eval_vendor/api/v1/evaluate_sellers?id=${this.evalDialogData.id}`);
                if (data.status && data.data.length) {
                    data.data.forEach((item) => {
                        this.evalData.push({
                            "eval_type": this.evalDialogData.permissionTabs,
                            "document_id": item.document_id || '-',
                            "po_number": item.po_number || '-',
                            "net_price": item.net_price || '-',
                            "vat_amount": item.vat_amount || '-',
                            "net_amount": item.net_amount || '-',
                            "currency": item.currency || '-',
                            "header_text": item.header_text || '-',
                            "vendor_name": item.vendor_name || '-',
                            "description": item.description || '-',
                            "transaction_id": this.evalDialogData.id
                        });
                    });
                    this.$store.commit('setEvalDetail', this.evalData)
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.callApiPending--
                if (!this.callApiPending) this.isReady = true;
            }
        }
    }
}
</script>
<style>
.custom-dialog-content {
    font-size: 15px;
    font-weight: bold;
    border-radius: 20px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.title-evalute {
    font-size: 28px;
}

.text-filed-custom.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 21px;
    min-width: 148px;
}

.text-filed-custom>.v-input__control>.v-input__slot>.v-text-field__slot input {
    max-height: 21px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    margin-right: 10px;
}

.text-filed-custom.v-text-field--outlined fieldset,
.textarea-custom.v-text-field--outlined fieldset {
    border-color: rgba(168, 168, 168, 1);
}

.textarea-custom.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea {
    max-height: 60px;
    font-size: 14px;
    font-weight: 400;
    margin-left: 10px;
    word-break: break-word;
    text-align: center;
}

.textarea-custom.v-textarea.v-text-field--enclosed .v-text-field__slot {
    margin-right: 0px !important;
}

.scroll-theme.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea::-webkit-scrollbar {
    width: 8px;
    background-color: transparent !important;
}

.scroll-theme.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.scroll-theme.v-textarea.v-text-field--enclosed.v-text-field--outlined.v-input--dense textarea::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(168, 168, 168, 1);
}

.btn-custom {
    background-color: #0B68D6;
    border-radius: 11px;
}

.btn-custom.v-size--default {
    font-size: 20px;
    font-weight: bold;
}
</style>